<template>
    <div>
        <b-toast
		id="toast-check-report-student"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		<b-toast
		id="toast-equis-report-student"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-equis.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>

        <b-breadcrumb>
            <b-breadcrumb-item to="/student/evaluations-reports">{{$t('evaluations-reports.title')}}</b-breadcrumb-item>
            <b-breadcrumb-item active><span v-if="data">{{data.teacher}}: </span> 
                <span>{{$t('evaluations-reports.sub-title')}}</span>
            </b-breadcrumb-item>
        </b-breadcrumb>
        <div class="card" style="margin-bottom:22px;">
            <div class="card-body">
                <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 32px;">
                    <div class="back-step mt-0"  @click="backStep">
                        <icon name="arrow-left"/>
                        {{$t('planesYPrecios.regresar')}}
                    </div>
                    <h4 class="sub-title d-flex mb-0" style="padding-right: 20px;">
                        <span>{{$t('evaluations-reports.text.1')}}</span>
                        <p class="mb-0" style="font-weight: 400;margin-left: 6px;" v-if="dataStudent">{{dataStudent.date}}</p>
                    </h4>
                  
                    <div class="d-flex align-items-center">
                    <a v-if="data.id > 0" class="link blue" @click="downloadFile"><span>{{$t('evaluations-reports.text.2')}}</span></a>
                        <icon v-if="data.id > 0" name="arrow-download"/>
                    </div>
                </div>
                <b-row class="evaluationCourse mb-0">
                    <b-col class="justify-content-center">
                        <div class="sub-title-img name">
                            <b-avatar
                            variant="light"
                            :src="urlPhoto"
                            ></b-avatar>
                            <div>
                                <span class="blue">{{$t('evaluations-reports.text.3')}}</span>
                                  <span v-if="data">
                                    <p>{{data.teacher}}</p>
                                    <!-- <p>{{dataStudent.flag ? `(${dataStudent.groupsCode})`: ''}}</p> -->
                                </span>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="justify-content-center">
                        <div class="sub-title-img name">
                            <img src="@/assets/img/progress-small.png">
                            <div>
                                <span class="blue">{{$t('evaluations-reports.text.4')}}</span>
                                <span v-if="dataStudent"><p  v-for="(item ,index) in dataStudent.subjectsStr" :key="index">{{item}}</p></span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card" id="reportCourse">
            <div class="card-body">
                <div class="container-courses" v-for="(item,index) in dataCourses" :key="`courses-${index}`">
                     <h4 class="sub-title d-flex mb-0 justify-content-center" style="padding-right: 20px;">
                        <span>{{$t('evaluations-reports.text.5')}}</span>
                        <p class="mb-0" style="font-weight: 400;margin-left: 6px;">{{item.subjectName}}</p>
                    </h4>
                    <div class="section_gray text" style="margin-top: 27px;margin-bottom:30px;">
                        <h6 class="bold" style="font-size: 15px;">{{$t('evaluations-reports.text.6')}}</h6>
                        <p class="mb-0">
                              {{item.comment}}
                        </p>
                    </div>
                    <h6 class="bold" style="font-size: 15px;">{{$t('evaluations-reports.text.7')}}</h6>
                    <b-list-group class="description-list">
                        <b-list-group-item>
                            <b-form-row>
                                <b-col cols="2"><h6 class="bold">{{$t('evaluations-reports.description-list.1')}}</h6></b-col>
                                <b-col cols="1"><h6 class="bold">{{$t('evaluations-reports.description-list.2')}}</h6></b-col>
                                <b-col cols="1"><h6 class="bold">{{$t('evaluations-reports.description-list.3')}}</h6></b-col>
                                <b-col cols="8" style="padding-right: 30px;"><h6 class="bold">{{$t('evaluations-reports.description-list.4')}}</h6></b-col>
                            </b-form-row>
                        </b-list-group-item>
                        <b-list-group-item class="table-file">
                             <b-form-row v-if="item.listEvaluations.length==0">
                                <span style=" width: 100%;">{{$t('evaluations-reports.error.1')}}</span> 
                            </b-form-row>
                            <span v-else>
                                   <b-form-row v-for="(itemEval,index) in item.listEvaluations" :key="`evaluations-${index}`">
                                <b-col cols="2"><p>{{itemEval.strSubmittedDate}}</p></b-col>
                                <b-col cols="1"><p>{{itemEval.module}}</p></b-col>
                                <b-col cols="1"><p>{{itemEval.strScore}}</p></b-col>
                                <b-col cols="8" class="comments d-flex justify-content-between" style="padding-right: 30px;">
                                    <v-clamp autoresize :max-lines="1">
                                        {{itemEval.teacherComments}}
  
                                    </v-clamp>
                                    <span class="link blue view-more" @click="directionView(1,itemEval)">{{ 'View more' }}</span>
                                     
                                    <!-- <p>
                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                        nonummy nibh euismod tincidunt ut laoreet dolore...
                                    </p>
                                    <a class="link blue"><span>Download report</span></a> -->
                                </b-col>
                            </b-form-row>
                            </span>
                        </b-list-group-item>
                    </b-list-group>
                    <h6 class="bold" style="font-size: 15px;">{{$t('evaluations-reports.text.8')}}</h6>
                    <b-list-group class="description-list">
                        <b-list-group-item>
                            <b-form-row>
                                <b-col cols="2"><h6 class="bold">{{$t('evaluations-reports.description-list.1')}}</h6></b-col>
                                <b-col cols="1"><h6 class="bold">{{$t('evaluations-reports.description-list.2')}}</h6></b-col>
                                <b-col cols="1"><h6 class="bold">{{$t('evaluations-reports.description-list.3')}}</h6></b-col>
                                <b-col cols="8" style="padding-right: 30px;"><h6 class="bold">{{$t('evaluations-reports.description-list.4')}}</h6></b-col>
                            </b-form-row>
                        </b-list-group-item>
                        <b-list-group-item class="table-file">
                             <b-form-row v-if="item.listAssignments.length==0">
                                <span style=" width: 100%;">{{$t('evaluations-reports.error.2')}}</span> 
                            </b-form-row>
                            <span v-else>
                                <b-form-row v-for="(itemAssig,index) in item.listAssignments" :key="`assignment-${index}`">
                                <b-col cols="2"><p>{{itemAssig.strSubmittedDateHourShort}}</p></b-col>
                                <b-col cols="1"><p>{{itemAssig.module}}</p></b-col>
                                <b-col cols="1"><p>{{itemAssig.strScore}}</p></b-col>
                                <b-col cols="8" class="comments d-flex justify-content-between" style="padding-right: 30px;">
                                    <v-clamp autoresize :max-lines="1">
                                        {{itemAssig.teacherComments}}

                                    </v-clamp>
                                     <span class="link blue view-more" @click="directionView(2,itemAssig)">{{ 'View more' }}</span>
                                    <!-- 
                                        
                                         <b-link
                                            class="link blue"
                                            v-if="expanded || clamped"
                                            slot="after"
                                            slot-scope="{ toggle, expanded, clamped }"
                                            @click="toggle"
                                        >{{ expanded ? 'See Less' : 'View more' }}
                                        </b-link>
                                        <p>
                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                                        nonummy nibh euismod tincidunt ut laoreet dolore...
                                    </p>
                                    <a class="link blue"><span>Download report</span></a> -->
                                </b-col>
                            </b-form-row>
                            </span>
                        </b-list-group-item>
                    </b-list-group>
                    <h6 class="bold" style="font-size: 15px;">{{$t('evaluations-reports.text.9')}}</h6>
                    <b-list-group class="description-list" style="margin-bottom:20px;">
                        <b-list-group-item>
                            <b-form-row>
                                <b-col cols="1" style="padding-left: 30px;"><h6 class="bold">{{$t('evaluations-reports.description-list.5')}}</h6></b-col>
                                <b-col cols="2"><h6 class="bold">{{$t('evaluations-reports.description-list.6')}}</h6></b-col>
                               <!-- <b-col cols="3"><h6 class="bold">{{$t('evaluations-reports.description-list.7')}}</h6></b-col>-->
                                <b-col cols="4"><h6 class="bold">{{$t('evaluations-reports.description-list.8')}}</h6></b-col>
                                <b-col cols="5"><h6 class="bold">{{$t('evaluations-reports.description-list.9')}}</h6></b-col>
                            </b-form-row>
                        </b-list-group-item>
                        <b-list-group-item class="table-file">
                             <b-form-row v-if="item.listClasses.length==0">
                                <span style=" width: 100%;">{{$t('evaluations-reports.error.3')}}</span> 
                            </b-form-row>
                            <span v-else>
                                 <b-form-row v-for="(itemClass,index) in item.listClasses" :key="`classes-${index}`">
                                <b-col cols="1" style="padding-left: 8px;"><p>{{itemClass.dateClassString}}</p></b-col>
                                <b-col cols="2"><p>{{itemClass.scheduleTeacherDetail.strStartEnd}}</p></b-col>
                             
                                <b-col cols="4">
                                    <ul class="list-ul">
                                        <li>{{itemClass.strTopics}}</li>
                                    </ul>
                                </b-col>
                                <b-col cols="5" class="comments d-flex justify-content-between">
                                    <v-clamp autoresize :max-lines="1" style="flex:2">
                                        {{itemClass.comment}}
                                       
                                    </v-clamp>
                                    <span class="link blue view-more" @click="directionView(3,itemClass)">{{ 'View more' }}</span>
                                </b-col>
                            </b-form-row>
                                </span>
                           
                        </b-list-group-item>
                    </b-list-group>
                   <h6 class="bold" style="font-size: 15px;">
                    {{$t('evaluations-reports.text.10')}}
                    <span class="blue">{{item.stringHours}}</span>
                    </h6>
                </div>
               
                <div class="text-center" style="margin-top:52px">
                     <span class="desactiveLink ml-3" v-show="buttonPrev==0">
                        <icon name="arrow-left"/>
                        {{$t('evaluations-reports.buttons.1')}}
                    </span>
                    <a href="#" v-show="buttonPrev!=0"  class="linkReport mr-3" @click="getReportsPagination(buttonPrev)" >
                        <icon name="arrow-left"/>
                        {{$t('evaluations-reports.buttons.1')}}
                    </a>
                    <span class="desactiveLink ml-3" v-show="buttonNext==0">
                        {{$t('evaluations-reports.buttons.2')}}
                        <icon name="arrow-right"/>
                    </span>
                    <a href="#"   v-show="buttonNext!=0"   class="linkReport ml-3" @click="getReportsPagination(buttonNext)"   >
                        {{$t('evaluations-reports.buttons.2')}}
                        <icon name="arrow-right"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { IMAGENES } from '@/assets/js/appConstants'; 
export default {
    data(){
        return{
             lang:localStorage.getItem('lang') || 'es',
            message:null,
            data : null,
            dataStudent : null,
            dataCourses: [],
            buttonPrev : 0,
            buttonNext : 0,
            urlPhoto: IMAGENES.PHOTO_TEACHER_DEFAULT,
        }
    },
    created(){    
         
        if(this.$route.params.id == undefined){
            this.$router.push({
                    name : 'student/evaluations-reports',
                
                }).catch(err => {}); 
        }else{
            this.data = this.$route.params
     
            this.getData();
        }
    },

    methods:{
        directionView(num,item){
         
            switch (num) {
                case 1: case 2:{

                     let data = {
                        id : item.id,
                        flagReport :true,
                        type:1
                    }
                  
                    let param = btoa(JSON.stringify(data))
                    window.open(`${location.protocol}//${location.host}/student/class/intermediate/${param}`,'_blank')

                    break;
                }

                case 3:{
                    let data = {
                        id : item.id,
                        flagReport :true,
                        type:3
                    }
                    let param = btoa(JSON.stringify(data))
                    window.open(`${location.protocol}//${location.host}/student/class/intermediate/${param}`,'_blank')

                    break;
                }
                   
            
            }
        },
        backStep(){
            this.$router.go(-1)
        },
        getReportsPagination(id){
            this.data.id = id
  
            this.getData();
        },
        downloadFile(){
            this.isLoadingDow = true;
            let headers = {
                responseType : "blob"
            }
            let flag = this.lang == 'es' ? true : false;
            
            baseInstanceAxios.get(
                `${this.apiURL}/resources/PersonsStudentsReports/DownloadFileByReports?id=${this.data.id}&flagTeacher=true&flagLanguage=${flag}&timeZoneName=${this.$store.state.user.timeZoneName}` ,
                headers  )
             .then((response) => {
            
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const today = new Date().toLocaleDateString()
                const now = Date.now()
                const name = `report_${today}_${now}.xlsx`
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${name}.pdf`);
                document.body.appendChild(link);
                link.click();
                this.isLoadingDow = false;
            }).catch(() =>{
               
                this.message = this.$t('error.error-downloading-report');
                this.$bvToast.show("toast-equis-report-student");
                 this.isLoadingDow = false;
            });
            
        },
        getData(){

            this.data.listGroupRegisterSubjectIds = this.data.listGroupRegisterSubjectIds.map(x => (parseInt(x)))
            
            let body = {
                Id:this.data.id,
                FlagSearch:this.data.flagSearch,
                PersonTeacherId :this.data.personTeacherId,
                PersonsStudentId : this.data.personsStudentId,
                GroupPlanId: this.data.groupPlanId,
                ListGroupRegisterSubjectIds:this.data.listGroupRegisterSubjectIds,
                Year: this.data.year,
                Month: this.data.month,
                TimeZoneName: this.$store.state.user.timeZoneName,
            }
            
            this.dataCourses = [];
            baseInstanceAxios
            .post(`${this.apiURL}/resources/PersonsStudentsReports/PersonsStudentsReportsById`, body)
            .then(response => {
     
                if(response.data.entity){
                
                    this.dataStudent  = {
                        id : response.data.entity.id,
                        name : response.data.entity.personsStudent.person.strFullName,
                        date :  response.data.entity.strDateMonthReport,
                        groupsCode : response.data.entity.personsStudent.groupsCode,
                        flag : response.data.entity.personsStudent.flagGroup,
                        subjectsStr : this.data.nameCourses
                    }
                  
                    this.buttonPrev = response.data.entity.idPrev
                    this.buttonNext = response.data.entity.idNext
                   
                    response.data.entity.listPersonsStudentsReports.forEach(element => {
                    
                        //Evaluations
                        let arrayEvaluations = response.data.entity.listPersonsEvaluations.filter((elementEv) => {
                            return element.groupRegisterSubjectId == elementEv.groupRegisterSubjectId
                        })
                        arrayEvaluations.map((element )=>{
                            element.strSubmittedDate = this.lang == 'es' ?  element.strSubmittedDateHourShort :  element.strSubmittedDateHourShort_EN

                            return element
                        })
                          //Assignments
                        let arrayAssignments =  response.data.entity.listPersonsAssignments.filter((elementEv) => {
                            return element.groupRegisterSubjectId == elementEv.groupRegisterSubjectId
                        })

                          //Classes
                        let arrayClasses =  response.data.entity.listGroupsPlanClass.filter((elementEv) => {
                            return element.groupRegisterSubjectId == elementEv.groupRegisterSubjectId
                        })
                        // Deduplicate by same date+time slot
                        const seenClasses = {};
                        arrayClasses = arrayClasses.filter(c => {
                            const key = `${c.dateClassString}_${c.scheduleTeacherDetail.strStartEnd}`;
                            if (seenClasses[key]) return false;
                            seenClasses[key] = true;
                            return true;
                        });



                        let totalHoursClass = arrayClasses.reduce((acum,curr,currIndex,array)=>{
                            return acum+curr.scheduleTeacherDetail.totalHoursClass
                        },0)
                      
                        let horas   = Math.floor(totalHoursClass);
                        let minutos   = Math.floor((totalHoursClass - horas) * 60);
                        let stringHours = this.lang == 'es' ?
                          (horas == 0 && minutos > 0) ? `${minutos} minutos`  : (horas == 1 && minutos == 0) ?  `${horas} hora` : (horas == 1 && minutos > 0) ? `${horas} hora ${minutos} minutos` : (horas > 1 && minutos == 0) ? `${horas} horas` : `${horas} horas ${minutos} minutos`
                         :(horas == 0 && minutos > 0) ? `${minutos} minutes`  : (horas == 1 && minutos == 0) ?  `${horas} hour` : (horas == 1 && minutos > 0) ? `${horas} hour ${minutos} minutes` : (horas > 1 && minutos == 0) ? `${horas} hours` : `${horas} hours ${minutos} minutes`;
                            

                      
                        let json = {
                            id : element.id,
                            subjectName:element.subjectName,
                            groupRegisterSubjectId:element.groupRegisterSubjectId,
                            comment : element.comment,
                            listEvaluations : arrayEvaluations,
                            listAssignments : arrayAssignments,
                            listClasses : arrayClasses,
                            stringHours : stringHours
                        }

                        this.dataCourses.push(json)
                    });
                
                }
                
            }); 
        }
    }
}
</script>
<style>
/* .svg{
    fill: #508adf;
    width: 12px;
    margin-left: 12px;
} */
.section_gray.text::after{
    content: none;
}
</style>